import { createContext, useContext, type ReactNode } from "react";
import type { NavigateFunction } from "react-router";
// Define the context type
interface RemoteContextType {
  accessedFromHost?: boolean;
  navigate: NavigateFunction | undefined;
  WorkSessionID?: string;
  WorkGroupID?: string;
  UserId?: string;
  marketingInsightRequestId?: string;
  ClientId?: string;
}

// Provide a default value
export const RemoteProviderContext = createContext<
  RemoteContextType | undefined
>(undefined);

export const RemoteProvider: React.FC<{
  accessedFromHost?: boolean;
  children: ReactNode;
  WorkSessionID: string | undefined; // uuid
  WorkGroupID: string | undefined;
  UserId: string | undefined;
  navigate?: NavigateFunction | undefined;
  marketingInsightRequestId?: string;
  ClientId?: string;
}> = ({ accessedFromHost, children, WorkSessionID, WorkGroupID, UserId, ClientId, marketingInsightRequestId, navigate }) => {
  return (
    <RemoteProviderContext.Provider
      value={{
        accessedFromHost,
        navigate,
        WorkGroupID,
        WorkSessionID,
        UserId,
        marketingInsightRequestId,
        ClientId,
      }}
    >
      {children}
    </RemoteProviderContext.Provider>
  );
};

export const useRemote = () => {
  const context = useContext(RemoteProviderContext);
  if (!context) {
    throw new Error("useRemote must be used within a RemoteProvider");
  }
  return context;
};
